import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Label } from '~/components/ui/label'

type IProps = {
  initialNeeds?: string
  orgName: string
  busy: boolean
  onSubmit: (needs: string) => void
  onCancel?: () => void
}

/**
 * La demande d'aménagement (#327) : le besoin, et le consentement explicite que
 * demande une donnée de santé (RGPD, art. 9). Sans case cochée, rien ne part.
 */
function AccommodationForm({ initialNeeds = '', orgName, busy, onSubmit, onCancel }: IProps) {
  const { t } = useTranslation()
  const [needs, setNeeds] = useState(initialNeeds)
  const [consent, setConsent] = useState(false)
  const valid = !!needs.trim() && consent

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    if (valid) onSubmit(needs)
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="accommodationNeeds" required>{t('accommodation.needs')}</Label>
        <textarea id="accommodationNeeds" rows={4} maxLength={2000} required value={needs} onChange={e => setNeeds(e.target.value)} aria-describedby="accommodationNeedsHelp" className="rounded-md border border-input bg-transparent px-3 py-2 text-sm" />
        <p id="accommodationNeedsHelp" className="text-xs text-muted-foreground">{t('accommodation.needsHelp')}</p>
      </div>
      <label className="flex items-start gap-2 text-sm">
        <input type="checkbox" className="mt-1" checked={consent} onChange={e => setConsent(e.target.checked)} />
        {t('accommodation.consent', { org: orgName })}
      </label>
      <div className="flex flex-wrap gap-2">
        <Button type="submit" disabled={!valid || busy}>{t('accommodation.send')}</Button>
        {onCancel && <Button type="button" variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>}
      </div>
    </form>
  )
}

export default AccommodationForm
